export const flagTitle = "mGXuTc";
export const unflagTitle = "lSeUid";
export default {flagTitle,unflagTitle};